import { Config, SettingsConfig } from "./configType";

export const nimbleSettings: SettingsConfig = {
  apiManagement: process.env.REACT_APP_NIM_APIM,
  ocpApimSubscriptionKey: process.env.REACT_APP_NIM_APIM_KEY,
  googleApiKey: process.env.REACT_APP_NIM_GOOGLE_API_KEY,
  authority: process.env.REACT_APP_NIM_AUTHORITY,
  bankStatementIframeUrl: process.env.REACT_APP_NIM_BANK_STATEMENTS_IFRAME,
  authUrl: process.env.REACT_APP_NIM_AUTH_URL,
  appUrl: process.env.REACT_APP_NIM_APP_URL,
  cookieDomain: process.env.REACT_APP_NIM_COOKIE_DOMAIN,
  authClientId: process.env.REACT_APP_NIM_AUTH_CLIENT_ID,
  newCustomerForm: process.env.REACT_APP_NIM_NEW_CUSTOMER_FORM,
  contentManagementUrl: process.env.REACT_APP_NIM_CDS_URL,
  contentToken: process.env.REACT_APP_NIM_CDS_TOKEN,
  ezidebitUrl: process.env.REACT_APP_NIM_EZIDEBIT_URL,
  gtmId: process.env.REACT_APP_NIM_GTM_ID,
  gtmAuth: process.env.REACT_APP_NIM_GTM_AUTH,
  gtmPreview: process.env.REACT_APP_NIM_GTM_PREVIEW,
  phone: process.env.REACT_APP_NIM_PHONE,
  email: process.env.REACT_APP_NIM_EMAIL,
  abn: process.env.REACT_APP_NIM_ACN,
  acl: process.env.REACT_APP_NIM_ACL,
  faq: process.env.REACT_APP_NIM_FAQ,
  companyName: process.env.REACT_APP_NIM_COMPANY_NAME,
  privacy: process.env.REACT_APP_NIM_PRIVACY_POLICY,
  cdsPrefix: process.env.REACT_APP_NIM_CDS_PREFIX,
  cdsApp: process.env.REACT_APP_NIM_CDS_APP,
  privacyConsentAndElectronicAuthorisation: process.env.REACT_APP_NIM_PRIVACY_CONSENT_AND_ELECTRONIC_AUTHORISATION,
  creditGuide: process.env.REACT_APP_NIM_CREDIT_GUIDE,
  directDebitBank: process.env.REACT_APP_NIM_DIRECT_DEBIT_BANK,
  directDebitBSB: process.env.REACT_APP_NIM_DIRECT_DEBIT_BSB,
  directDebitAccountNumber: process.env.REACT_APP_NIM_DIRECT_DEBIT_ACCOUNT_NUMBER,
  vwoAccountId: process.env.REACT_APP_NIM_VWO_ACCOUNT_ID,
  magicBlocksWorkspaceId: process.env.REACT_APP_NIM_MAGICBLOCKS_WORKSPACE_ID,
  magicBlocksExperienceId: process.env.REACT_APP_NIM_MAGICBLOCKS_EXPERIENCE_ID,
  magicBlocksTestMode: process.env.REACT_APP_NIM_MAGICBLOCKS_TEST_MODE
};

export const nimbleConfig: Config = {
  partnerLogo: 'nimble-partnership-logo.svg',
  LOCName: "AnyTime"
};

export const nimbleFavicon = '/favicon-nimble.png';
